import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './logintype.component.html'
})
export class LogintypeComponent {

  constructor(private router: Router) {
    // debugger;
    console.log('LogintypeComponent loaded (should not happen)');
  }

  public onSubmitSSO() {
    this.router.navigate(['/loginping']);
  }

  public onSubmitCredential() {
    this.router.navigate(['/extlogin']);
  }
}


